import useSeo from "@/lib/useSeo";

export default function Terms() {
  useSeo({
    title: "Terms & Conditions | ClariDent RCM",
    description: "The terms and conditions governing use of the ClariDent RCM website and information about our dental revenue cycle management services.",
    path: "/terms",
  });

  return (
    <main data-testid="terms-page">
      <section className="bg-slate-50 py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <h1 className="font-display text-5xl tracking-tighter font-black text-navy-900">Terms & Conditions</h1>
          <p className="mt-4 text-sm text-slate-500">Last updated: August 2026</p>
        </div>
      </section>
      <section className="max-w-3xl mx-auto px-6 py-16 space-y-8 text-sm sm:text-base text-slate-600 leading-relaxed">
        <div>
          <h2 className="font-display text-2xl font-semibold text-navy-900 mb-3">Use of this website</h2>
          <p>This website is provided by ClariDent RCM for general information about our dental revenue cycle management services. Content on this site does not constitute legal, financial, or billing advice for any specific practice.</p>
        </div>
        <div>
          <h2 className="font-display text-2xl font-semibold text-navy-900 mb-3">Services</h2>
          <p>Specific services, pricing, and deliverables are defined in individual service agreements between ClariDent RCM and each client practice. Information on this website is illustrative and may be updated as our services evolve.</p>
        </div>
        <div>
          <h2 className="font-display text-2xl font-semibold text-navy-900 mb-3">Intellectual property</h2>
          <p>The ClariDent RCM name, logo, and website content are the property of ClariDent RCM. Practice management software names referenced on this site belong to their respective owners; reference does not imply partnership or endorsement.</p>
        </div>
        <div>
          <h2 className="font-display text-2xl font-semibold text-navy-900 mb-3">Contact</h2>
          <p>Questions about these terms can be sent to <a href="mailto:Billing@claridentrcm.com" className="text-teal-600 font-semibold">Billing@claridentrcm.com</a>.</p>
        </div>
      </section>
    </main>
  );
}
